import { createSlice } from "@reduxjs/toolkit";

const notificationManagementSlice = createSlice({
    name: 'notificationManagement',
    initialState: {
        data: [],
        isLoading: false
    },
    reducers: {
        startLoading: (state) => { state.isLoading = true; },
        stopLoading: (state) => { state.isLoading = false; },
        getUpdateNotification: (state, action) => { state.data = action.payload; },
    }
});

const notificationManagementActions = notificationManagementSlice.actions;

export { notificationManagementActions };
export default notificationManagementSlice.reducer;